import { RadioOption } from "../forms/types";
import "./RadioGroup.scss";

interface RadioGroupProps {
  name: string;
  label: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  error?: string;
  hasOtherInput?: boolean;
  otherFieldName?: string;
  otherValue?: string;
  onOtherChange?: (value: string) => void;
}

const RadioGroup = ({
  name,
  label,
  options,
  value,
  onChange,
  error,
  hasOtherInput,
  otherValue = "",
  onOtherChange,
}: RadioGroupProps) => {
  return (
    <div className="radio-group">
      {label && <label className="radio-group__label">{label}</label>}
      <ul className="radio-group__list">
        {options.map((option) => (
          <li
            key={option.value}
            className={`radio-group__item${
              value === option.value ? " radio-group__item--checked" : ""
            }`}
            onClick={() => onChange(option.value)}
          >
            <span className="radio-group__option-label">{option.label}</span>
            <span className="radio-group__radio">
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
                className="radio-group__input"
              />
              <span className="radio-group__dot" />
            </span>
          </li>
        ))}
      </ul>

      {hasOtherInput && value === "other" && (
        <input
          type="text"
          className="radio-group__other-input"
          placeholder="Wpisz rodzaj"
          value={otherValue}
          onChange={(e) => onOtherChange?.(e.target.value)}
        />
      )}

      {error && <span className="radio-group__error">{error}</span>}
    </div>
  );
};

export default RadioGroup;
